import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import resources from './resources'
import { IntlProvider } from 'react-intl'
import { Provider } from 'react-redux'
import { store } from './store'
import { setUpInterceptor } from './utils/interceptor'
import { BookerVersions } from 'booker'
import { BookerWrapperTheme } from './components/BookerWrapper'
import qs from 'qs'

type LocaleType = 'es-mx' | 'en-us'
const container = document.querySelector('.itm-booker')
const searchParams = new URLSearchParams(document.location.search)

const getLocale = () => {
   const language = container?.getAttribute('data-language') || searchParams.get('language')
   switch (language) {
      case 'es-mx':
         return 'es-mx' as LocaleType
      case 'en-us':
         return 'en-us' as LocaleType
   }
   return 'es-mx' as LocaleType
}
const allResources = {
   'es-mx': {
      ...resources['es-mx'],
   },
   'en-us': {
      ...resources['en-us'],
   },
}

const supLocale = getLocale()
const messages = allResources[supLocale]

const root = createRoot(container!)
const accountCode = container?.getAttribute('data-account') || searchParams.get('dev-account')
const hotelIdString = container?.getAttribute('data-hotel') || searchParams.get('dev-hotel')
const hotelId = hotelIdString && !isNaN(parseInt(hotelIdString)) ? parseInt(hotelIdString) : null
const hideNavbar =
   container?.getAttribute('data-loadingnavbar') === 'false' || searchParams.get('dev-hideNavbar') === 'true'
const devOnlyShow = container?.getAttribute('data-only-show-form') || searchParams.get('dev-onlyShowForm')
const customUri = container?.getAttribute('data-custom-uri') || searchParams.get('dev-customUri')
const forceDestinationIdOnUrl =
   container?.getAttribute('data-force-destination-id-on-url') === 'true' ||
   searchParams.get('dev-forceDestinationIdOnUrl') === 'true'
const devVersion = container?.getAttribute('data-version') || searchParams.get('dev-version')
const fontFamilyName =
   container?.getAttribute('data-font-family-name') || searchParams.get('dev-fontFamilyName') || 'helvetica'
const bgColor = searchParams.get('dev-bgColor')
const devInline = searchParams.get('dev-inline')
const devShowArrows = searchParams.get('dev-showArrows')
const devShowLabels = searchParams.get('dev-showLabels')
const devShowDatesFirst = searchParams.get('dev-showDatesFirst')
const servicesEmbeded = searchParams.get('embeded')

let theme: BookerWrapperTheme | null = null
try {
   const devParams = qs.parse(searchParams.toString(), {
      ignoreQueryPrefix: true,
      allowDots: true,
      decoder: function (str: string, defaultDecoder: qs.defaultDecoder, charset: string, type: 'key' | 'value') {
         if (
            type === 'value' &&
            /^(?:-(?:[1-9](?:\d{0,2}(?:,\d{3})+|\d*))|(?:0|(?:[1-9](?:\d{0,2}(?:,\d{3})+|\d*))))(?:.\d+|)$/.test(str)
         ) {
            return parseFloat(str)
         }

         const keywords: Record<string, boolean | null | undefined> = {
            true: true,
            false: false,
            null: null,
            undefined: undefined,
         }
         if (type === 'value' && str in keywords) {
            return keywords[str]
         }

         return defaultDecoder(str, defaultDecoder, charset)
      },
   })
   theme = devParams.theme ? (devParams.theme as BookerWrapperTheme) : null
} catch (e) {
   console.error('Error parsing styleOptions:', e)
}

let dataOnlyFormToShow = null
let version = null
switch (devOnlyShow) {
   case 'HOTEL':
      dataOnlyFormToShow = 'HOTEL' as const
      break
   case 'HOTEL_FLIGHT':
      dataOnlyFormToShow = 'HOTEL_FLIGHT' as const
      break
   case 'SERVICES':
      dataOnlyFormToShow = 'SERVICES' as const
      break
}
switch (devVersion) {
   case 'padded':
      version = 'padded' as BookerVersions
      break
   case 'regular':
      version = 'regular' as BookerVersions
      break
}

setUpInterceptor(store)
accountCode &&
   root.render(
      <React.StrictMode>
         <Provider store={store}>
            <IntlProvider locale={supLocale} messages={messages}>
               {(bgColor || fontFamilyName) && (
                  <style>
                     {`
                     ${
                        fontFamilyName
                           ? `
                     :root{
                        --booker-font-family: "${fontFamilyName}"
                     }`
                           : ''
                     }
                     ${
                        bgColor
                           ? `
                     html {
                        background-color: ${bgColor};
                     }`
                           : ''
                     }
                  `}
                  </style>
               )}
               <App
                  accountCode={accountCode}
                  locale={supLocale}
                  hideNavbar={hideNavbar}
                  dataOnlyFormToShow={dataOnlyFormToShow}
                  {...(customUri && { customUri })}
                  {...(hotelId && { hotelId })}
                  {...(forceDestinationIdOnUrl && { forceDestinationIdOnUrl: true })}
                  {...(version && { version })}
                  {...(theme && { theme })}
                  searchParams={searchParams}
                  devOptions={{
                     ...(devInline && {
                        inline: devInline === 'true' ? true : devInline === 'false' ? false : null,
                     }),
                     ...(devShowArrows && {
                        showArrows: devShowArrows === 'true' ? true : devShowArrows === 'false' ? false : null,
                     }),
                     ...(devShowLabels && {
                        showLabels: devShowLabels === 'true' ? true : devShowLabels === 'false' ? false : null,
                     }),
                     ...(devShowDatesFirst && {
                        showDatesFirst:
                           devShowDatesFirst === 'true' ? true : devShowDatesFirst === 'false' ? false : null,
                     }),
                     ...(servicesEmbeded && { servicesEmbeded: servicesEmbeded === 'true' }),
                  }}
               />
            </IntlProvider>
         </Provider>
      </React.StrictMode>,
   )
